import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "11",
  height: "9.54979",
  viewBox: "0 0 11 9.54979",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      id: "Vector",
      opacity: "0.4",
      d: "M9.5 6.12078C10.1541 5.40744 10.5 4.7749 10.5 4.7749C10.5 4.7749 8.6818 1.44998 5.5 1.44998C5.3294 1.44998 5.1627 1.45954 5 1.47763C4.8289 1.49666 4.6622 1.52513 4.5 1.56185M5.5 3.34993C5.6753 3.34993 5.8436 3.3785 6 3.43102C6.4262 3.57412 6.764 3.89503 6.91465 4.29991C6.9699 4.44848 7 4.60836 7 4.7749M1 0.500001L10 9.04979M5.5 6.19986C5.3247 6.19986 5.1564 6.17127 5 6.11878C4.5738 5.97567 4.23599 5.65476 4.08535 5.24988C4.05693 5.17351 4.03517 5.09414 4.02073 5.01239M1.5735 3.34993C1.41938 3.51357 1.28117 3.67407 1.15932 3.82492C0.72643 4.3608 0.5 4.7749 0.5 4.7749C0.5 4.7749 2.31818 8.09981 5.5 8.09981C5.6706 8.09981 5.8373 8.09027 6 8.07217",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }